import { createTheme } from '@mui/material';
import { defaultStyleComponents } from './defaultStyleComponents';
import { defaultDarkColor, defaultLightColor } from './defaultColors';

export const defaultLightTheme = createTheme(
  {
    components: { ...defaultStyleComponents },
    spacing: (abs: number) => `${0.35 * abs}rem`,
    palette: {
      mode: 'light',
      primary: {
        main: '#E50914',
        '50': '#FFF5F5',
        '100': '#FFE5E6',
        '200': '#FFCCCE',
        '300': '#FF999D',
        '400': '#FF666B',
        '500': '#E50914',
        '600': '#B8070F',
        '700': '#8B050B',
        '800': '#5E0307',
        '900': '#2F0103',
      },
      ...defaultLightColor,
      customColor: {
        main: '#E50914',
        100: '#B8070F',
        gradient:
          'linear-gradient(90deg, rgba(229, 9, 20, 0.1) 0%, rgba(229, 9, 20, 0.3) 100%)',
      },
      customColor2: {
        main: '#141414',
      },
      customColorTable: {
        main: '#E50914',
        oddRow: '#FFF5F5',
      },
    },
  },
);

export const defaultDarkTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'dark',
    primary: {
      main: '#E50914',
      '50': '#1a1a1a',
      '100': '#2a2a2a',
      '200': '#3a3a3a',
      '300': '#4a4a4a',
      '400': '#E50914',
      '500': '#F40612',
      '600': '#FF1A26',
      '700': '#FF3340',
      '800': '#FF4D59',
      '900': '#141414',
    },
    ...defaultDarkColor,
    customColor: {
      main: '#E50914',
      100: '#F40612',
      gradient:
        'linear-gradient(90deg, rgba(20, 20, 20, 0.8) 0%, rgba(229, 9, 20, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#E50914',
      oddRow: '#1a1a1a',
    },
  },
});
